import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { LoginModel } from 'app/pages/content-pages/login/login-page.component';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { AccessibleClientModel, UnreadNotificationModel } from 'app/dashboard/home/home.component';

@Injectable({
  providedIn: 'root'   // 🔥 IMPORTANT
})
export class AuthService {

  private jwtHelper = new JwtHelperService(); // ✅ create once

  constructor(
    public router: Router,
    private _client: HttpClient
  ) {}

  signinUser(model: LoginModel) {
    return this._client.post(`${environment.apiUrl}users/auth`, model, { withCredentials: true });
  }

  logout() {
    localStorage.removeItem('id-t');
    this.router.navigate(['/pages/login']);
  }

  // ✅ SAFE AUTH CHECK
  isAuthenticated(): boolean {
    const token = localStorage.getItem('id-t');

    if (!token) return false;

    return !this.jwtHelper.isTokenExpired(token);
  }

  // ✅ SAFE USER DECODE
  static GetCurrentUser(): UserInfo | null {
    const token = localStorage.getItem('id-t');

    if (!token) return null;

    return new JwtHelperService().decodeToken<UserInfo>(token);
  }

  getAccessibleClientList(platform: string): Observable<Array<AccessibleClientModel>> {
    return this._client.get<Array<AccessibleClientModel>>(
      `${environment.apiUrl}clients/getAccessibleClientList?platform=${platform}`
    );
  }

  getHOShiftSupport() {
    return this._client.get(`${environment.apiUrl}clients/getHOShiftSupport`);
  }

  generateClientToken(appType: string, clientId: string) {
    return this._client.get(
      `${environment.apiUrl}home/auth/client?appType=${appType}&clientId=${clientId}`
    );
  }

  getUnreadNotificationCount(appType: string): Observable<UnreadNotificationModel> {
    return this._client.post<UnreadNotificationModel>(
      `${environment.notificationApiUrl}get-unread-count`,
      { appType: appType }
    );
  }

  // ✅ CLEAN URL BUILDER
  getRequestedUserList(
    requestTypeId: number,
    pageNum: number,
    pageSize: number,
    uName?: string,
    mName?: string,
    ip?: string,
    deviceUID?: string,
    pcType?: string,
    region?: string
  ) {
    let url = `${environment.apiUrl}authenticateUser/getRequestedUserList?requestTypeId=${requestTypeId}&pageNumber=${pageNum}&pageSize=${pageSize}`;

    if (uName) url += `&userName=${encodeURIComponent(uName)}`;
    if (mName) url += `&machineName=${encodeURIComponent(mName)}`;
    if (ip) url += `&ipAddress=${encodeURIComponent(ip)}`;
    if (deviceUID) url += `&deviceUID=${encodeURIComponent(deviceUID)}`;
    if (pcType) url += `&pcType=${encodeURIComponent(pcType)}`;
    if (region) url += `&region=${encodeURIComponent(region)}`;

    return this._client.get<any>(url);
  }

  authenticateUserbyId(
    requestId: number,
    statusId: number,
    accessType?: string,
    hours?: number
  ) {
    let url = `${environment.apiUrl}authenticateUser/authenticateUser?requestId=${requestId}&statusId=${statusId}`;

    if (accessType) {
      url += `&accessType=${encodeURIComponent(accessType)}`;
    }

    if (hours !== undefined && hours !== null) {
      url += `&hours=${hours}`;
    }

    return this._client.post(url, null);
  }
}

// ✅ MODEL
export class UserInfo {
  id!: string;
  firstName!: string;
  lastName!: string;
  name!: string;
  loginId!: string;
  roleIds!: string;
}